module.exports = __webpack_public_path__ + "ca79bfae4c2a1187ae1aa5789ce25756.svg";